<template>
  <div class="parallax">
    <div class="parallax-curtain">
      <div class="text-center mx-auto w-50 pt-5">
        <h1 class="header-title pb-1">Jakob Jentsch</h1>
        <h2 style="color: rgb(185, 185, 185)" class="fw-normal pb-5">
          Gründer von Voice Art Productions
        </h2>
        <div class="row text-start">
          <div class="col">
            <p lang="de" class="text-white px-3 fs-5 fw-lighter bio">
              Als echter Berliner, mit echt vielen Geschwistern und echtem
              Interesse an den Dingen, die er macht, ist ihm wichtig, dass seine
              Arbeit mit den Kund*innen und seine Projekte genauso echt bleiben
              wie die Geschichten dahinter und die Menschen, die sie erzählen.
              Denn Jakob steht voll und ganz hinter den Dingen: In der Schule
              noch hinterher, seit der Jugend hinter internationalen DJ-Pults,
              das BWL-Studium hinterher nochmal kritisch hinterfragt,
            </p>
          </div>

          <div class="col">
            <p lang="de" class="text-white px-3 fs-5 fw-lighter bio">
              daraufhin mit Leidenschaft und Präzision hinter seinem
              Musikstudium. Am Wochenende hinter seiner Fußballmannschaft und
              hinter dem von ihm (und seinen Freunden!) geliebten Pizzaofen. Vom
              Musiker, Produzenten und DJ aus dem Rampenlicht immer mehr hinter
              die Kulissen und als Soundengineer mit viel Liebe hinter jedem
              einzelnen Projekt. Nicht geradlinig, aber echt!
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.parallax {
  background-color: rgb(0, 0, 0);
  background-image: url("../assets/images/jakob_sw.jpg");
  height: 100%;
  /* Create the parallax scrolling effect */
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  /*following just for demo purposes to add height and top padding*/
  /* height: 118vh; */
  height: 138vh;
  padding-top: 68vh;
}
.parallax-curtain {
  height: 70vh;
  background: rgba(0, 0, 0, 0.85);
}
</style>
